import React, { useState, useMemo, useRef, useEffect } from 'react';
import { FormControl, InputAdornment, TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../hooks/redux.hooks';
import TodayIcon from '@mui/icons-material/Today';
import { CustomTextField } from '../../../theme/elements/Inputs';
import { useTheme } from '@mui/material';
import CalendarPopover from 'components/FormElements/CalendarPopover';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { isValid, format } from 'date-fns';
import { formatDate } from 'constants/global.constants';
import { timing } from 'constants/ui.constants';
import { Clear } from '@mui/icons-material';
import _ from 'lodash';

type props = {
	handleChange: any;
	selectedDate: any;
	name: string;
	label?: string;
	styleObj?: any;
};

export const CalendarPickerInput = (props: props) => {
	const theme = useTheme();
	const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
	const { handleChange, selectedDate, name, label } = props;
	const [showCalender, setShowCalender] = useState(false);
	const id = showCalender ? 'simple-calender-popover' : undefined;

	const handleClose = () => {
		setAnchorEl(null);
		setShowCalender(false);
	};

	const handleClick = (event: any) => {
		setAnchorEl(event.currentTarget);
		setShowCalender(true);
	};

	const handleChangeDatePick = (item: any) => {
		//setSelectedDate(item);
		if (handleChange) {
			handleChange(item);
		}
	};

	const displayDate = useRef(null);

	useEffect(() => {
		if (!_.isNull(displayDate.current)) {
			displayDate.current.value =
				!_.isNull(selectedDate) && isValid(new Date(selectedDate)) ? format(selectedDate, timing.DATE) : '';
		}
	}, [selectedDate]);

	return (
		<CustomTextField key={name} sx={{ ...props.styleObj }}>
			<FormControl fullWidth>
				<TextField
					inputRef={(ref) => (displayDate.current = ref)}
					label={anchorEl === null && selectedDate === null ? label : ''}
					onClick={handleClick}
					size="small"
					autoComplete="off"
					InputProps={{
						//value:formatSelectedDate,
						readOnly: true,
						endAdornment: (
							<InputAdornment position="end">
								<TodayIcon
									sx={{
										color: showCalender
											? theme.palette.root.orange
											: theme.palette.root.basicDeeoGreen,
									}}
								/>
							</InputAdornment>
						),
					}}
				/>
				<CalendarPopover
					id={id}
					showCalender={showCalender}
					anchorEl={anchorEl}
					value={selectedDate}
					handleClose={handleClose}
					onChange={handleChangeDatePick}
				/>
			</FormControl>
		</CustomTextField>
	);
};
